
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"13.125","viewBox":"0 0 14 13.125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 151266","d":"M12.25 2.625H10.5V1.313A1.331 1.331 0 009.187 0H4.812A1.331 1.331 0 003.5 1.313v1.312H1.75A1.762 1.762 0 000 4.375v7a1.762 1.762 0 001.75 1.75h10.5a1.762 1.762 0 001.75-1.75v-7a1.762 1.762 0 00-1.75-1.75zM4.375 1.313a.432.432 0 01.437-.437h4.375a.432.432 0 01.437.437v1.312H4.375zm8.75 10.062a.864.864 0 01-.875.875H1.75a.864.864 0 01-.875-.875v-3.5h3.937v1.75a.432.432 0 00.437.437h3.5a.432.432 0 00.437-.437v-1.75h3.937zM5.687 9.188V7.875h2.625v1.312zM13.125 7H.875V4.375A.864.864 0 011.75 3.5h10.5a.864.864 0 01.875.875z","fill":"#0079f2"}})])
          )
        }
      }
    